export const churches = [
  // {
  //   name: "Amazing Grace Baptist Church, Ilupeju",
  //   slug: "Amazing Grace Baptist Church, Ilupeju",
  // },
  // {
  //   name: "Araromi Baptist Church, Mushin",
  //   slug: "Araromi Baptist Church, Mushin",
  // },
  // {
  //   name: "Christ Baptist Church, Anthony",
  //   slug: "Christ Baptist Church, Anthony",
  // },
  // {
  //   name: "Divine Mercy Baptist Church, Ikosi",
  //   slug: "Divine Mercy Baptist Church, Ikosi",
  // },
  // {
  //   name: "First Baptist Church, Ajegunle",
  //   slug: "First Baptist Church, Ajegunle",
  // },
  // {
  //   name: "First Baptist Church, Alapere",
  //   slug: "First Baptist Church, Alapere",
  // },
  // {
  //   name: "Christ The Rock Mende",
  //   slug: "Christ The Rock Mende",
  // },
  // {
  //   name: "First Baptist Church, Kosofe",
  //   slug: "First Baptist Church, Kosofe",
  // },
  // {
  //   name: "First Baptist Church, Ojota",
  //   slug: "First Baptist Church, Ojota",
  // },
  // {
  //   name: "Gideon Baptist Church, Fadeyi",
  //   slug: "Gideon Baptist Church, Fadeyi",
  // },
  // {
  //   name: "Gideon Baptist Church, Tube",
  //   slug: "Gideon Baptist Church, Tube",
  // },
  // {
  //   name: "Maranatha Baptist Church, Ikosi",
  //   slug: "Maranatha Baptist Church, Ikosi",
  // },

  // {
  //   name: "Mount Zion Baptist Church, Shangisa",
  //   slug: "Mount Zion Baptist Church, Shangisa",
  // },
  // {
  //   name: "Mushin Baptist Church, Ashabi",
  //   slug: "Mushin Baptist Church, Ashabi",
  // },
  // {
  //   name: "New Creation Baptist Church, Ogudu",
  //   slug: "New Creation Baptist Church, Ogudu",
  // },
  {
    name: "New Light Baptist Church, Magodo",
    slug: "New Light Baptist Church, Magodo",
  },
  // {
  //   name: "New Nations Baptist Church, Maryland",
  //   slug: "New Nations Baptist Church, Maryland",
  // },
  // {
  //   name: "Salem Baptist Church, Agiliti",
  //   slug: "Salem Baptist Church, Agiliti",
  // },
  // {
  //   name: "Shepherdhill Baptist Church, Obanikoro",
  //   slug: "Shepherdhill Baptist Church, Obanikoro",
  // },
  // {
  //   name: "Glad Tidings Baptist Church, Idi-agbon",
  //   slug: "Glad Tidings Baptist Church, Idi-agbon",
  // },
  // {
  //   name: "New Radiance Baptist Church",
  //   slug: "New Radiance Baptist Church",
  // },
  // {
  //   name: "Christ Model Baptist Church Akute",
  //   slug: "Christ Model Baptist Church Akute",
  // },
];

export const ranks = [
  {
    name: "Assistant Intern",
  },
  {
    name: "Intern",
  },
  {
    name: "Senior Intern",
  },
  {
    name: "Envoy",
  },
  {
    name: "Special Envoy",
  },
  {
    name: "Senior Envoy",
  },
  {
    name: "Dean",
  },
  // {
  //   name: "Test",
  // },
];
